import {Patient} from "../../../models/Patient";
import LogoSalmoiraghiVigano from '../../../assets/SalmoiraghiVigano.svg'
import LogoGrandVision from '../../../assets/GrandVision.svg'
import {
    Button,
    Checkbox,
    Col,
    DatePicker, Flex,
    Form,
    FormProps,
    Image,
    Input,
    InputNumber,
    Radio,
    Row,
    Space,
    Typography
} from "antd";
import {useTranslation} from "react-i18next";
import {CambioVisusFormData} from "../../../models/cambioVisus";
import {DiottrieTable} from "../DiottrieTable";
import {FirmaInput} from "../FirmaInput";
import {getLogoFromIntegrationCode} from "../../Common/logoUtils";
import React, {useState} from "react";
import {CambioVisusInfo} from "../CambioVisusInfo";
import {DateField} from "../DateField";
import {InputFloatNumber} from "../InputFloatNumber";
import {RadioChangeEvent} from "antd/es/radio";

const FormItem = Form.Item<CambioVisusFormData>;

export interface CambioVisusGenericProps{
    onClose: ()=>void
    patient?: Patient,
    insuranceProviderIntegrationCode: string;
    isSubmitting: boolean;
    onSubmit: (data: CambioVisusFormData) => void;
    shopGroup: string;
}
export function CambioVisusGeneric(props: CambioVisusGenericProps) {
    const [form] = Form.useForm();
    const { t, i18n } = useTranslation();
    const [previousDiottrieRequired, setPreviousDiottrieRequired] = useState(false);
    const [newDiottrieRequired, setNewDiottrieRequired] = useState(false);

    const onSubmit: FormProps<CambioVisusFormData>['onFinish'] = (data) => {
        props.onSubmit(data);
    };

    function onClose ():void  {
        props.onClose();
    };

    function logo()  {
        const logo =  getLogoFromIntegrationCode(props.insuranceProviderIntegrationCode);
        if ('' === logo) {
            if (props.shopGroup == 'GV') {
                return LogoGrandVision;
            } else {
                return LogoSalmoiraghiVigano;
            }
        }
        return logo;
}

    const integrationCode = props.insuranceProviderIntegrationCode;
    const key = "cambioVisus" + integrationCode;
    /*
    const onPortatoreLentiChange = (e: RadioChangeEvent, prefixOfFieldsToReset: string) => {
        setPreviousDiottrieRequired(e.target.value);
        resetFieldsWithPrefix(prefixOfFieldsToReset);
    }

    const onCambioVisusChange = (e: RadioChangeEvent, prefixOfFieldsToReset: string) => {
        setNewDiottrieRequired(e.target.value);
        resetFieldsWithPrefix(prefixOfFieldsToReset);
    }

    const resetFieldsWithPrefix = (prefix: string) => {
        const allFields = form.getFieldsValue();
        const fieldsToReset = Object.keys(allFields)
            .filter((fieldName) => fieldName.startsWith(prefix))
            .map((name) => ({
                name,
                errors: [],
            }));
        form.setFields(fieldsToReset);
    };
    */
    return (
        <div>
            { props.shopGroup!=='SVF' &&  <Image
                preview={false}
                width={300}
                src={logo()}
            />}
            <Form
                form={form}
                scrollToFirstError
                key={key}
                layout="vertical"
                onFinish={onSubmit}
            >
                <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                    <div>
                        <strong>{t("insured")}</strong>
                        <FormItem
                            name="assicurato"
                            label="Cognome Nome"
                            rules={[
                                {
                                    required: true,
                                    message: "Inserisci il nome dell'assicurato",
                                },
                            ]}
                            initialValue={props?.patient?.name}
                        >
                            <Input />
                        </FormItem>
                    </div>
                    <div>
                        L'Assicurato presenta il seguente{" "}
                        <strong>vizio di rifrazione</strong>
                        <Row gutter={15}>
                            <Col span={6}>
                                <FormItem name="miopia" label="Miopia" valuePropName="checked">
                                    <Checkbox/>
                                </FormItem>
                            </Col>
                            <Col span={6}>
                                <FormItem name="ipermetropia" label="Ipermetropia" valuePropName="checked">
                                    <Checkbox/>
                                </FormItem>
                            </Col>
                            <Col span={6}>
                                <FormItem name="presbiopia" label="Presbiopia" valuePropName="checked">
                                    <Checkbox/>
                                </FormItem>
                            </Col>
                            <Col span={6}>
                                <FormItem name="astigmatismo" label="Astigmatismo" valuePropName="checked">
                                    <Checkbox/>
                                </FormItem>
                            </Col>
                        </Row>
                    </div>
                    <FormItem
                        name="portatoreLenti"
                        label="L'Assicurato è già portatore di lenti per correggere il difetto:"
                        rules={[
                            {
                                required: true,
                                message: "Seleziona una voce",
                            },
                        ]}
                    >
                        <Radio.Group /*onChange={e => onPortatoreLentiChange(e, 'previous')}*/>
                            <Radio value={true}>Si</Radio>
                            <Radio value={false}>No</Radio>
                        </Radio.Group>
                    </FormItem>
                    <div>
                        Indicare le <strong>precedenti</strong> diottrie:
                        <DiottrieTable prefix="previous" isRequired={previousDiottrieRequired} />
                    </div>
                    <FormItem
                        name="cambioVisus"
                        label="Se non rilevabili le precedenti diottrie, l'assistito dichiara un effettivo cambio del visus:"
                        rules={[
                            {
                                required: true,
                                message: "Seleziona una voce",
                            },
                        ]}
                    >
                        <Radio.Group /*onChange={e => onCambioVisusChange(e, 'current')}*/>
                            <Radio value={true}>Si</Radio>
                            <Radio value={false}>No</Radio>
                        </Radio.Group>
                    </FormItem>
                    <div>
                        Indicare le <strong>attuali</strong> diottrie:
                        <DiottrieTable prefix="current" isRequired={newDiottrieRequired} />
                    </div>
                    <Row>
                        <Col span={12}>
                            <FormItem
                                name="distanzaInterpupillare"
                                label={<strong>Distanza interpupillare mm</strong>}
                            >
                                <InputFloatNumber min={0} />
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem name="note" label="Note">
                                <Input.TextArea />
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <FormItem
                                name="dataDoc"
                                label="Data"
                                rules={[
                                    {
                                        required: true,
                                        message: "Selezionare una data",
                                    },
                                ]}
                            >
                                <DateField />
                            </FormItem>
                        </Col>
                        <Col span={12}>
                            <FormItem name="firma" rules={[{ required: true, message: 'Inserire la firma prima di procedere'}]}>
                                <FirmaInput />
                            </FormItem>
                        </Col>
                    </Row>
                    <CambioVisusInfo shopGroup={props.shopGroup}/>
                    <Flex justify="flex-end">
                        <Space>
                            <FormItem>
                                <Button htmlType="button" onClick={onClose}>Annulla</Button>
                            </FormItem>
                            <FormItem>

                                <Button
                                    loading={props.isSubmitting}
                                    type="primary"
                                    htmlType="submit"
                                >
                                    Salva
                                </Button>
                            </FormItem>

                        </Space>
                    </Flex>
                </Space>
            </Form>
        </div>
    );
}
